export default class MemberChartItem {

    public time: string;
    public value: number;

    constructor(data: any) {
        this.time = data.time;
        this.value = data.value;
    }

}
